// Страница «Определить регион и оператора по номеру»

import createComponent from "../vue";

import cleanUploader from "../clean/uploader/clean-uploader";
import validators from "../clean/validators";

import scrollTo from "../components/scroll-to";
import calculator from "../clean/calculator";
import paymentBlock from "../payments/payment-block";
import "../phone/demo";

function initUploader() {
    createComponent({
        components: { cleanUploader },
        data() { return { validator: validators.getTextErrors }; },
    }, ".js-clean-uploader");
}

initUploader();
scrollTo.init();

if (window.DA.user.isAuthenticated) {
    import("../profiles/invoice").then(() => {
        calculator.Calculator(document.querySelector(".js-calculator"));
        paymentBlock.init();
        paymentBlock.initWithInput();
    });
}
